export default __webpack_public_path__ + "static/media/notes.0cc69386.svg";